/**
 * Email del pagador para el checkout de Mercado Pago.
 *
 * OJO: `user.username` es el id (sub) de Cognito, no un email: Mercado Pago
 * rechaza el checkout con "Invalid value for payer_email". El AuthContext
 * expone el email real en `user.email` (loginId o claim `email` del idToken).
 * Orden: user.email → user.attributes (loginId) → user.username (solo si es un
 * email) → organization.contactEmail. Devuelve null si ninguno es válido.
 */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) => typeof value === 'string' && EMAIL_RE.test(value.trim());

export function getPayerEmail(user, organization) {
  const candidates = [
    user?.email,
    user?.attributes,
    user?.username,
    organization?.contactEmail,
    organization?.email,
  ];
  const found = candidates.find(isValidEmail);
  return found ? found.trim() : null;
}
